import {
  APPROVED_PRODUCTS_LIST_RESPONSE,
  PRODUCT_DETAILS_RESPONSE,
  PRODUCT_VERSION_DETAILS_RESPONSE,
  REVIEW_REQUESTS_LIST_RESPONSE
} from "./types";

const INITIAL_STATE = {
  reviewRequests: {
    list: [],
    meta: {}
  },
  approvedProducts: {
    list: [],
    meta: {}
  },
  productDetails: {},
  productVersionDetails: {}
};

const products = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REVIEW_REQUESTS_LIST_RESPONSE:
      return {
        ...state,
        reviewRequests: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case APPROVED_PRODUCTS_LIST_RESPONSE:
      return {
        ...state,
        approvedProducts: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case PRODUCT_DETAILS_RESPONSE:
      return {
        ...state,
        productDetails: action.payload
      };
    case PRODUCT_VERSION_DETAILS_RESPONSE:
      return {
        ...state,
        productVersionDetails: action.payload
      };
    default:
      return state;
  }
};

export default products;
